module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-blue-english.e2343ca7.png";